import React, { Component } from 'react'
import {
  MessageComponentProps,
  MessageBubble,
  MessageBubbleText,
  FirebaseMessage
} from '@deal/chat-firebase'
import { Image } from '@deal/components'
import { Link } from 'react-router-dom'
import { IdentityConsumer } from '#src/containers/Identity'
import {
  NewCurationComponent,
  ExpertCuratedItemActivationComponent,
  MessageRichCardType
} from '#src/generated/graphql'
import CurationIcon from './curation.svg'
import styles from './styles.css'
import CategoryIcon from '#src/components/CategoryIcon'

export default class ProductCuration extends Component<MessageComponentProps> {
  public static handlesMessage(message: FirebaseMessage) {
    const curatedMessagePartBodyTypes = [
      'new-expert-curated-items',
      'new-system-curated-items',
      'updated-expert-curated-items'
    ]
    const richCardTypes = [
      MessageRichCardType.NEW_EXPERT_CURATED_ITEMS,
      MessageRichCardType.NEW_SYSTEM_CURATED_ITEMS,
      MessageRichCardType.UPDATED_EXPERT_CURATED_ITEMS
    ]

    return (
      message.parts.length > 1 &&
      message.parts[0].type == 'TEMPLATE_CAROUSEL' &&
      (richCardTypes.includes(message.parts[0].body.richCardType) ||
        curatedMessagePartBodyTypes.includes(message.parts[0].body.type)) &&
      message.parts[0].body.queryVariables &&
      (message.parts[0].body.queryVariables.leadId ||
        message.parts[0].body.queryVariables.expertCuratedItemActivationId)
    )
  }

  public render() {
    const activationId = this.props.message.parts[0].body.queryVariables
      .expertCuratedItemActivationId
    const curatedByExpert = this.props.message.parts[0].body.type !== 'new-system-curated-items'

    if (activationId) {
      return (
        <IdentityConsumer>
          {({ myself }) => (
            <ExpertCuratedItemActivationComponent variables={{ activationId }}>
              {({ data, loading }) => {
                if (data && data.expertCuratedItemActivation) {
                  const expert = data.expertCuratedItemActivation.activatedBy
                  const itemCount = data.expertCuratedItemActivation.activated.length

                  const category =
                    data.expertCuratedItemActivation.lead &&
                    data.expertCuratedItemActivation.lead.category
                  const banner =
                    category &&
                    category.contentAssets.bannerImages &&
                    category.contentAssets.bannerImages[0]

                  const leadId = data.expertCuratedItemActivation.lead.id
                  return (
                    <MessageBubble message={this.props.message}>
                      <div className={styles.hero}>
                        {banner && (
                          <Image
                            src={banner.imageUrl!}
                            width={384}
                            height={134}
                            imgixParams={{ fit: 'crop' }}
                            className={styles.heroImage}
                            onMounted={this.props.onLoaded}
                          />
                        )}

                        <div className={styles.overlay}>
                          {category && (
                            <>
                              <CategoryIcon
                                className={styles.categoryIcon}
                                categoryName={category.name}
                              />
                              <div className={styles.break} />
                            </>
                          )}

                          {`${expert.firstName}'s picks ${myself &&
                            `for ${myself.user.firstName}`}`}
                        </div>
                      </div>
                      {curatedByExpert && (
                        <div className={styles.caption}>
                          <CurationIcon className={styles.curationIcon} />
                          {itemCount === 1 ? 'Hand' : `${itemCount} hand`} picked items for you.
                        </div>
                      )}
                      <Link to={`/curations/products/${leadId}`} className={styles.cta}>
                        {curatedByExpert ? 'View Your Options' : 'View Your Recommendations'}
                      </Link>
                    </MessageBubble>
                  )
                } else if (loading) {
                  return (
                    <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                      Loading...
                    </MessageBubbleText>
                  )
                } else {
                  return (
                    <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                      Error loading messages!
                    </MessageBubbleText>
                  )
                }
              }}
            </ExpertCuratedItemActivationComponent>
          )}
        </IdentityConsumer>
      )
    } else {
      const leadId = this.props.message.parts[0].body.queryVariables.leadId
      // legacy message where we don't have activation id in the variable list, only has leadId
      return (
        <IdentityConsumer>
          {({ myself }) => (
            <NewCurationComponent variables={{ leadId }} fetchPolicy="network-only">
              {({ data, loading }) => {
                if (data && data.expertCuratedItemsForLead) {
                  const expert = data.lead.expert
                  const categories = data.expertCuratedItemsForLead.byCategories.categories
                  const itemCount = categories.reduce((count, edge) => {
                    return count + edge.items.length
                  }, 0)

                  const category = data.lead && data.lead.category
                  const banner =
                    category &&
                    category.contentAssets.bannerImages &&
                    category.contentAssets.bannerImages[0]
                  return (
                    <MessageBubble message={this.props.message}>
                      <div className={styles.hero}>
                        {banner && (
                          <Image
                            src={banner.imageUrl!}
                            width={384}
                            height={134}
                            imgixParams={{ fit: 'crop' }}
                            className={styles.heroImage}
                            onMounted={this.props.onLoaded}
                          />
                        )}

                        <div className={styles.overlay}>
                          {category && (
                            <>
                              <CategoryIcon
                                className={styles.categoryIcon}
                                categoryName={category.name}
                              />
                              <div className={styles.break} />
                            </>
                          )}

                          {`${expert.firstName}'s picks ${myself &&
                            `for ${myself.user.firstName}`}`}
                        </div>
                      </div>
                      {curatedByExpert && (
                        <div className={styles.caption}>
                          <CurationIcon className={styles.curationIcon} />
                          {itemCount === 1 ? 'Hand' : `${itemCount} hand`} picked items for you.
                        </div>
                      )}
                      <Link to={`/curations/products/${leadId}`} className={styles.cta}>
                        {curatedByExpert ? 'View Your Options' : 'View Your Recommendations'}
                      </Link>
                    </MessageBubble>
                  )
                } else if (loading) {
                  return (
                    <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                      Loading...
                    </MessageBubbleText>
                  )
                } else {
                  return (
                    <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                      Error loading messages!
                    </MessageBubbleText>
                  )
                }
              }}
            </NewCurationComponent>
          )}
        </IdentityConsumer>
      )
    }
  }
}
